import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { AuthLink } from 'components/auth/common/AuthLink/AuthLink'
import { Box } from 'components/layout/Box/Box'
import { LanguageSwitch } from '../../common/LanguageSwitch/LanguageSwitch'

import { LOGIN, toLogin } from 'ducks/router'
import { useAuthLayout } from './hooks'

import Logo from 'assets/icons/ebber-logo.svg'

import styles from './AuthLayout.module.scss'

type AuthLayoutProps = {
  children?: React.ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { state, handlers } = useAuthLayout()

  const { language, type } = state
  const { handleSwitchLanguage } = handlers

  return (
    <Box className={styles.layout} direction="column">
      <Box
        align="center"
        className={styles.header}
        justify="space-between"
        tagName="header"
      >
        <img className={styles.logo} src={Logo} alt="Ebber" />
        <Box align="center">
          {!R.equals(type, LOGIN) ? (
            <AuthLink
              className={styles.login}
              label={t`Sign in`}
              variant="filled"
              to={toLogin()}
              redirect
            />
          ) : null}
          <LanguageSwitch
            onSwitchLanguage={handleSwitchLanguage}
            {...{ language }}
          />
        </Box>
      </Box>
      <Box
        align="center"
        className={styles.main}
        justify="center"
        tagName="main"
      >
        <Box
          align="center"
          className={styles.content}
          direction="column"
          justify="center"
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
